import {
    buildCreateApi,
    coreModule,
    reactHooksModule,
} from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './AxiosAPI';
import {
    createDispatchHook,
    createSelectorHook,
    createStoreHook,
} from 'react-redux';
import { StoreContext } from './StoreContext';

const customCreateApi = buildCreateApi(
    coreModule(),
    reactHooksModule({
        useDispatch: createDispatchHook(StoreContext),
        useSelector: createSelectorHook(StoreContext),
        useStore: createStoreHook(StoreContext),
    })
);

export const RootApi = customCreateApi({
    baseQuery: axiosBaseQuery(),
    endpoints: () => ({}),
});
